import { useTranslation } from 'react-i18next';

export function Switch({
    name,
    label = '',
    checked = false,
    onChange,
    ...props
}) {
    const { t } = useTranslation();

    return (
        <div className="custom-control custom-switch">
            <input
                type="checkbox"
                checked={checked}
                onChange={onChange}
                id={name}
                className="custom-control-input"
                {...props}
            />
            <label
                htmlFor={name}
                className="custom-control-label"
                data-label-on={t('field.switchLabel.on')}
                data-label-off={t('field.switchLabel.off')}
            >
                <span className="custom-label-text">{label}</span>
            </label>
        </div>
    );
}
